import React from "react";
import styled from "styled-components";

import FinaSidebar from "./components/FinaSidebar";
import FinaContent from "./components/FinaContent";
import MobileAction from "./components/MobileAction";

import { useMediaQuery } from "./hooks/hooks";
import { GREY } from "./utils/colors";
import { IFinaLayoutProps } from "./types";
import { routes } from "./routes";

const Layout = styled.main`
  min-width: 100vw;
  min-height: 100vh;
  padding: 0;
  margin: 0;
  background-color: ${GREY};
`;

const FinaLayout: React.FC<IFinaLayoutProps> = ({
  headerContent,
  children,
}) => {
  const mobile = useMediaQuery("(max-width: 767px)");
  const laptop = useMediaQuery("(min-width: 767px) and (max-width: 992px)");
  /* Open is the resting state where there is room for it: the labels are the
     navigation, and a reader should not have to hover a column of glyphs to
     learn what the app contains. It was collapsed by default, on the
     reasoning that the icons carry it and the page gets the width back — but
     that trades a permanent cost in legibility for width the content was not
     short of.
     Narrow widths still start closed, where the rail would take most of the
     screen; the effect below keeps that true if the window crosses the
     breakpoint later. */
  const [collapse, setCollapse] = React.useState<boolean>(mobile || laptop);
  React.useEffect(() => {
    /* Narrow widths have no room to be open, so a change of breakpoint into
       one closes it. Widening again leaves it as the reader had it. */
    if ((mobile || laptop) && !collapse) setCollapse(true);
    // eslint-disable-next-line
  }, [mobile, laptop]);

  return (
    <Layout>
      <FinaSidebar
        collapse={collapse}
        setCollapse={setCollapse}
        isMobile={mobile}
        routes={routes}
      />
      <FinaContent
        collapse={collapse}
        setCollapse={setCollapse}
        isMobile={mobile}
        // headerContent={headerContent}
      >
        {children}
      </FinaContent>
      <MobileAction />
    </Layout>
  );
};

export default FinaLayout;
